import React from 'react';
import { connect } from 'react-redux';
import _forEach from 'lodash/forEach';
import PropTypes from 'prop-types';
// Custom
import { reinitState } from 'actions';
import { getHocDisplayName } from 'utils/Tools';

const withStateReinit = (targets) => (WrappedComponent) => {
  class WithStateReinit extends React.Component {
    componentWillUnmount() {
      const { dispatchReinitState } = this.props;
      _forEach(targets, (target) => {
        dispatchReinitState(target);
      });
    }

    render() {
      return (
        <WrappedComponent {...this.props} />
      );
    }
  }

  WithStateReinit.displayName = getHocDisplayName('WithStateReinit', WrappedComponent);

  WithStateReinit.propTypes = {
    dispatchReinitState: PropTypes.func.isRequired,
  };

  const mapDispatchToProps = (dispatch) => ({
    dispatchReinitState: (target) => dispatch(reinitState(target)),
  });

  return connect(
    null,
    mapDispatchToProps,
  )(WithStateReinit);
};

export default withStateReinit;



// WEBPACK FOOTER //
// ./hocs/WithStateReinit.js